(function () {

    'use strict';
    angular.module('iplusjs.mapper.objectValue', [
        'lodash'
    ])
    .directive('iplusjsObjectValueMapper', objectValueMapper);

    objectValueMapper.$inject = [
        'lodash'
    ];
    function objectValueMapper(_) {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1000,
            scope: {
                data: '=iovmData',
                property: '@iovmProperty'
            },
            link: function ($scope, $element, $attr, $ngModel) {
                function toModel(value) {
                    return _.isObject(value) ? _.get(value, $scope.property) : value;
                }

                function toView(value) {
                    if (_.isArray($scope.data)) {
                        if ($scope.property) {
                            return _.find($scope.data, [$scope.property, _.isUndefined(value) ? null : value]);
                        } else {
                            return $scope.data[value];
                        }
                    } else if (_.isObject($scope.data)) {
                        return _.get($scope.data, $scope.property);
                    } else {
                        return value;
                    }
                }

                $ngModel.$parsers.push(toModel);
                $ngModel.$formatters.push(toView);
            }
        };
    }
})();
